import React, { Component } from 'react'
import gql from 'graphql-tag'
import { graphql } from 'react-apollo'
import { Redirect, withRouter } from 'react-router-dom'

import { Loader } from '../containers/Loader'
import { isAuthenticated, deleteUser, logout } from '../utils'
import { URLS } from '../constants'

class Logout extends Component {
  state = {
    loggedOut: false,
  }

  handleLogout = async () => {
    const result = await this.props.mutate()
    if (result.data.logoutUser.success) {
      deleteUser()
      logout()
      this.setState({ loggedOut: true })
    }
  }

  render() {
    const { loggedOut } = this.state
    if (loggedOut || !isAuthenticated()) {
      return <Redirect to={URLS.LOGIN} />
    }
    this.handleLogout()
    return <Loader />
  }
}

const LOGOUT_MUTATION = gql`
  mutation LogoutUser {
    logoutUser {
      success
    }
  }
`

export default graphql(LOGOUT_MUTATION)(withRouter(Logout))



// WEBPACK FOOTER //
// ./src/components/Logout.jsx